import * as React from "react";

export const ChatIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.5} clipPath="url(#a)" fill="currentColor">
      <path d="M16.12 18.944c.17 0 .34.065.469.19a3.13 3.13 0 0 0 3.09.727 6 6 0 0 1-.25-4.586c.66-1.888.826-3.78.074-5.679a7.28 7.28 0 0 0-3.547-3.842q.15.795.15 1.612a8.66 8.66 0 0 1-2.503 6.122A8.7 8.7 0 0 1 7.51 16.08a9 9 0 0 1-1.281-.074 7.41 7.41 0 0 0 6.307 3.721 7.3 7.3 0 0 0 3.292-.716.7.7 0 0 1 .291-.066" />
      <path d="M7.53.001C3.423-.08.01 3.241 0 7.347a7.3 7.3 0 0 0 .598 2.931 6 6 0 0 1-.25 4.587 3.13 3.13 0 0 0 3.09-.728.675.675 0 0 1 .76-.123 7.3 7.3 0 0 0 3.292.716c4.074-.06 7.266-3.296 7.266-7.365 0-3.98-3.242-7.283-7.226-7.364M3.442 8.465a1.067 1.067 0 1 1-.001-2.134 1.067 1.067 0 0 1 .001 2.134m3.936 0a1.067 1.067 0 1 1-.002-2.134 1.067 1.067 0 0 1 .002 2.134m3.935 0a1.067 1.067 0 1 1-.001-2.134 1.067 1.067 0 0 1 .001 2.134" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
